import React from 'react'
import { useAppointmentData } from '../hooks';
import Typography from '@material-ui/core/Typography'
import moment from 'moment'

export const ConfirmAppointment = () => {

    /**
     * Pull Appointment Data from store
     * show the data
     * button to restart. (on restart, refresh the state, restart the appointment)
     * button to make payment(on payment create appointment record) 
     */

    const appointment = useAppointmentData();
    console.log(`Appointment:${JSON.stringify(appointment, 1, 3)}`)

    const ui =
        <React.Fragment>
            <Typography variant="body1">
                The meeting is set up on <b>{moment(appointment.slot.appointmentDate).format('DD MMMM YYYY')}</b> at <b>{appointment.slot.appointmentTime}</b></Typography>
            <Typography variant="body1">
                The meentees will be mentored by <b>{appointment.mentor.name}</b> for <b>{appointment.slot.duration}</b> minutes
            </Typography>
            <Typography variant="body1">
                The meetees to the meeting will be  <b>{appointment.mentees.map(m => m.name + ", ")} </b>
            </Typography>
        </React.Fragment>
    return ui;
}